// src/components/AddressEditor.jsx
import React from 'react';
import AddressInput from '@components/AddressInput';
import { addressFields } from '@utils/addressForm';

export default function AddressEditor({
  addrQuery,
  setAddrQuery,
  addressFieldsState,
  handleAddressChange,
  applyTomTomPlace,
}) {
  return (
    <>
      <AddressInput
        value={addrQuery}
        onChange={setAddrQuery}
        labelText={addressFieldsState.street} // floating label matches your UX
        countries={['US', 'GB']}
        center={{ lat: 40.73, lon: -73.94 }}
        onSelect={(place) => applyTomTomPlace(place)}
      />

      <form>
        <div className='row g-3'>
          {addressFields
            .filter((f) => f.id !== 'street')
            .map((field) => (
              <div
                key={field.id}
                className={`form-floating col-lg-${field.col}`}
              >
                <input
                  type='text'
                  id={field.id}
                  value={addressFieldsState[field.id] || ''}
                  onChange={(e) =>
                    handleAddressChange(field.id, e.target.value)
                  }
                  className='form-control'
                  placeholder={field.label}
                />
                <label htmlFor={field.id}>{field.label}</label>
              </div>
            ))}
        </div>
      </form>
    </>
  );
}
